import { ShoppingBagIcon } from "lucide-react";
import { useEffect, useState } from "react";

type LogoIconProps = {
  imageId: string;
  type: "shop" | "user";
  className?: string;
};

export default function LogoIcon({ imageId, type, className }: LogoIconProps) {
  const [file, setFile] = useState<any>(null);

  useEffect(() => {
    // Fetch image file from API or other source
    const fetchImage = async () => {
      try {
        // Replace with your API endpoint or data fetching logic
        const response = await fetch(`/api/images/${imageId}`);
        const data = await response.json();
        setFile(data);
      } catch (error) {
        console.error("Error fetching image:", error);
      }
    };

    if (imageId) {
      fetchImage();
    }
  }, [imageId]);

  return (
    <div className="flex items-center">
      <span
        className={`h-4 w-4 rounded-full overflow-hidden bg-gray-100 ${className || ""}`}
      >
        {file ? (
          <img className="h-full object-cover" src={file.link} alt="Logo" />
        ) : type === "shop" ? (
          <ShoppingBagIcon className="h-full w-full text-gray-300" />
        ) : (
          <svg
            className="h-full w-full text-gray-300"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
          </svg>
        )}
      </span>
    </div>
  );
}
